import { takeEvery } from 'redux-saga';
import { toastr } from 'react-redux-toastr';

import { $post, $put } from '../_utils/restSaga';

import {
  sendMessageSuccess,
  justifyMessageSuccess,
  sendMessageFailure,
  justifyMessageFailure,
  SEND_MESSAGE,
  JUSTIFY_MESSAGE
} from './actions';

function* sendMessageSuccessAction() {
  toastr.success('Un message vient d\'être envoyé');
}

function* sendMessageFailureAction() {
  toastr.error('Impossible d\'envoyer le message');
}

function* justifyMessageSuccessAction() {
  toastr.success('Justification enregistrée');
}

function* justifyMessageFailureAction() {
  toastr.error('Impossible d\'enregistrer la justification');
}

export default function*() {
  yield [
    takeEvery(SEND_MESSAGE.do, $post('/api/message/send',
      sendMessageSuccess, sendMessageFailure)),
    takeEvery(SEND_MESSAGE.success, sendMessageSuccessAction),
    takeEvery(SEND_MESSAGE.failure, sendMessageFailureAction),

    takeEvery(JUSTIFY_MESSAGE.do, $put('/api/message/#{id}',
      justifyMessageSuccess, justifyMessageFailure)),
    takeEvery(JUSTIFY_MESSAGE.success, justifyMessageSuccessAction),
    takeEvery(JUSTIFY_MESSAGE.failure, justifyMessageFailureAction)
  ];
}



// WEBPACK FOOTER //
// ./src/redux/messages/saga.js